import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";

import {
  IIndividualListData,
  IIndividualTypeColor,
  ISelectedAccountListData,
  ISelectedAccountTransactionsListData,
  ISelectedLoansListData,
  ISelectedSavingsHistoryData,
  ISelectedSavingsListData,
  ISelectedTransactionsListData,
  ISelectedWithdrawalHistoryData,
} from "./types";

export const columns = [
  "Full Name",
  "Tier",
  "KYC",
  "Balance",
  "Compliance",
  "Date Joined",
  "Last Login Date",
  "Status",
  "",
];

export const accountColumns = [
  "Account Name",
  "Account Number",
  "Balance",
  "Status",
  "Freeze Status",
  "Date Created",
  "",
];

export const accountTransactionsColumns = [
  "Date and Time",
  "Description",
  "Type",
  "Reference",
  "Amount",
  "Balance",
];

export const transactionsColumns = [
  "Date and Time",
  "Type",
  "Description",
  "Reference",
  "Amount",
  "Current Balance",
  "Status",
];

export const loansColumns = [
  "Request Date",
  "Loan Amount",
  "Tenor",
  "Disbursement",
  "Loan Status",
  "",
];

export const savingsColumns = [
  "Name",
  "Savings Type",
  "Target Amount",
  "Amount Saved",
  "Interest Earned",
  "Start Date",
  "End Date",
  "Funding By",
  "Status",
  "",
];

export const savingsHistoryColumns = [
  "Transaction",
  "Amount",
  "Funding Source",
  "Date And Time",
  "",
];

export const withdrawalHistoryColumns = [
  "Amount",
  "Fee",
  "Reasons",
  "Status",
  "Date Requested",
  "Date Approved",
];

export const PAGE_LIMIT = 5;
export const FIRST_INDEX = 0;
export const SECOND_INDEX = 1;
export const THIRD_INDEX = 2;

export const INDIVIDUALS_LIST_TABLE_PAGE_LIMIT = 10;
export const INDIVIDUALS_LIST_TABLE_PAGINATION_PARAMS: IPaginationParams = {
  page: PAGE_ONE,
  limit: INDIVIDUALS_LIST_TABLE_PAGE_LIMIT,
};

export const individualListData: IIndividualListData[] = [
  {
    id: "1",
    fullName: "Stanley Agbo",
    tier: "Tier 1",
    kyc: "3/3",
    balance: "₦30,000.00",
    compliance: "approved",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "active",
    email: "stanley@example.com",
    freezeStatus: "frozen",
    postNoDebit: false,
    isGoalSavings: false,
    isGoalSavingsPaused: true,
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
  },
  {
    id: "2",
    fullName: "Ayodele Oluwadahunsi",
    tier: "Tier 3",
    kyc: "2/3",
    balance: "₦30,000.00",
    compliance: "rejected",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "inactive",
    email: "ayodele@example.com",
    freezeStatus: "frozen",
    postNoDebit: false,
    isGoalSavings: false,
    isGoalSavingsPaused: false,
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/particulars-of-directors-file-m5o154ty-particulars-of-directors.jpeg",
  },
  {
    id: "3",
    fullName: "Abeeb Ayinla",
    tier: "Tier 1",
    kyc: "3/3",
    balance: "₦30,000.00",
    compliance: "review",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "active",
    email: "abeeb@example.com",
    freezeStatus: "unfrozen",
    postNoDebit: true,
    isGoalSavings: true,
    isGoalSavingsPaused: true,
    imageUrl: "",
  },
  {
    id: "4",
    fullName: "Pelz Otaku",
    tier: "Tier 3",
    kyc: "3/3",
    balance: "₦30,000.00",
    compliance: "pending",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "inactive",
    email: "pelz@example.com",
    freezeStatus: "frozen",
    postNoDebit: true,
    isGoalSavings: true,
    isGoalSavingsPaused: false,
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/particulars-of-directors-file-m5o154ty-particulars-of-directors.jpeg",
  },
  {
    id: "5",
    fullName: "Muhammed Yayi",
    tier: "Tier 3",
    kyc: "3/3",
    balance: "₦30,000.00",
    compliance: "approved",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "active",
    email: "myayi@example.com",
    freezeStatus: "unfrozen",
    postNoDebit: false,
    isGoalSavings: false,
    isGoalSavingsPaused: true,
    imageUrl: "",
  },
  {
    id: "6",
    fullName: "Kehinde Talabi",
    tier: "Tier 3",
    kyc: "1/3",
    balance: "₦30,000.00",
    compliance: "approved",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "active",
    email: "kehinde@example.com",
    freezeStatus: "frozen",
    postNoDebit: true,
    isGoalSavings: true,
    isGoalSavingsPaused: true,
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/particulars-of-directors-file-m5o154ty-particulars-of-directors.jpeg",
  },
  {
    id: "7",
    fullName: "Joshua Katongo",
    tier: "Tier 1",
    kyc: "3/3",
    balance: "₦30,000.00",
    compliance: "pending",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "inactive",
    email: "jboy@example.com",
    freezeStatus: "unfrozen",
    postNoDebit: true,
    isGoalSavings: true,
    isGoalSavingsPaused: true,
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/particulars-of-directors-file-m5o154ty-particulars-of-directors.jpeg",
  },
  {
    id: "8",
    fullName: "Greenfield Rice",
    tier: "Tier 2",
    kyc: "2/3",
    balance: "₦30,000.00",
    compliance: "review",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "active",
    email: "greenfield@example.com",
    freezeStatus: "frozen",
    postNoDebit: true,
    isGoalSavings: true,
    isGoalSavingsPaused: true,
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/utility-bill-m5o1557s-utility-bill.jpeg",
  },
  {
    id: "9",
    fullName: "Yuri Zhakov",
    tier: "Tier 1",
    kyc: "3/3",
    balance: "₦30,000.00",
    compliance: "rejected",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "inactive",
    email: "yuri@example.com",
    freezeStatus: "unfrozen",
    postNoDebit: true,
    isGoalSavings: true,
    isGoalSavingsPaused: true,
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/particulars-of-directors-file-m5o154ty-particulars-of-directors.jpeg",
  },
  {
    id: "10",
    fullName: "Maximilliano Oddo",
    tier: "Tier 3",
    kyc: "3/3",
    balance: "₦30,000.00",
    compliance: "approved",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "active",
    email: "moddo@example.com",
    freezeStatus: "frozen",
    postNoDebit: true,
    isGoalSavings: true,
    isGoalSavingsPaused: true,
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/cac-file-m5o153xu-cac.jpg",
  },
  {
    id: "11",
    fullName: "Arose Aropade",
    tier: "Tier 3",
    kyc: "3/3",
    balance: "₦30,000.00",
    compliance: "review",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "active",
    email: "aarose@example.com",
    freezeStatus: "frozen",
    postNoDebit: true,
    isGoalSavings: true,
    isGoalSavingsPaused: true,
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/utility-bill-m5o1557s-utility-bill.jpeg",
  },
  {
    id: "12",
    fullName: "Vladmir Putina",
    tier: "Tier 1",
    kyc: "3/3",
    balance: "₦30,000.00",
    compliance: "rejected",
    dateJoined: "30th Mar, 2024",
    lastLoginDate: "31st Mar, 2024",
    status: "inactive",
    email: "vputin@example.com",
    freezeStatus: "frozen",
    postNoDebit: true,
    isGoalSavings: true,
    isGoalSavingsPaused: true,
    imageUrl:
      "https://earnipay-api-storage-dev.s3.eu-west-1.amazonaws.com/business-documents/particulars-of-directors-file-m5o154ty-particulars-of-directors.jpeg",
  },
];

export const selectedAccountListData: ISelectedAccountListData[] = [
  {
    id: "1",
    accountName: "Ayodele Oluwadahunsi",
    accountNumber: 51988299929,
    balance: 520223.89,
    status: "active",
    freezeStatus: "-",
    dateJoined: "30th Mar, 2024, 1:00pm",
  },
];

export const selectedAccountTransactionsListData: ISelectedAccountTransactionsListData[] =
  [
    {
      id: "1",
      date: "30th Mar, 2024",
      time: "1:00pm",
      transactionType: "credit",
      description: "Omotola Otubela",
      reference: "TRF-1729736726727",
      amount: 99473.34,
      balance: 140473.34,
    },
    {
      id: "2",
      date: "30th Mar, 2024",
      time: "1:00pm",
      transactionType: "debit",
      description: "Abeeb Crud",
      reference: "TRF-1729736726727",
      amount: 99473.34,
      balance: 140473.34,
    },
    {
      id: "3",
      date: "30th Mar, 2024",
      time: "1:00pm",
      transactionType: "credit",
      description: "Josh No-Funny",
      reference: "TRF-1729736726727",
      amount: 99473.34,
      balance: 140473.34,
    },
    {
      id: "4",
      date: "30th Mar, 2024",
      time: "1:00pm",
      transactionType: "debit",
      description: "Lawd Lugard",
      reference: "TRF-1729736726727",
      amount: 994730.34,
      balance: 140473.34,
    },
    {
      id: "5",
      date: "30th Mar, 2024",
      time: "1:00pm",
      transactionType: "debit",
      description: "MC Oluomo",
      reference: "TRF-1729736726727",
      amount: 99473.34,
      balance: 140473.34,
    },
  ];

export const selectedTransactionsListData: ISelectedTransactionsListData[] = [
  {
    id: "1",
    date: "30th Mar, 2024",
    time: "1:00pm",
    transactionType: "credit",
    description: "Omotola Otubela",
    reference: "TRF-1729736726727",
    amount: 99473.34,
    balance: 140473.34,
    status: "failed",
  },
  {
    id: "2",
    date: "30th Mar, 2024",
    time: "1:00pm",
    transactionType: "debit",
    description: "Abeeb Crud",
    reference: "TRF-1729736726727",
    amount: 99473.34,
    balance: 140473.34,
    status: "pending",
  },
  {
    id: "3",
    date: "30th Mar, 2024",
    time: "1:00pm",
    transactionType: "credit",
    description: "Josh No-Funny",
    reference: "TRF-1729736726727",
    amount: 99473.34,
    balance: 140473.34,
    status: "successful",
  },
  {
    id: "4",
    date: "30th Mar, 2024",
    time: "1:00pm",
    transactionType: "debit",
    description: "Lawd Lugard",
    reference: "TRF-1729736726727",
    amount: 994730.34,
    balance: 140473.34,
    status: "successful",
  },
  {
    id: "5",
    date: "30th Mar, 2024",
    time: "1:00pm",
    transactionType: "debit",
    description: "MC Oluomo",
    reference: "TRF-1729736726727",
    amount: 99473.34,
    balance: 140473.34,
    status: "pending",
  },
];

export const selectedLoansListData: ISelectedLoansListData[] = [
  {
    id: "1",
    date: "16 Aug, 2024",
    time: "12:30 PM",
    amount: 99473.34,
    tenor: 4,
    status: "failed",
  },
  {
    id: "2",
    date: "16 Aug, 2024",
    time: "12:30 PM",
    amount: 99473.34,
    tenor: 6,
    status: "pending",
  },
  {
    id: "3",
    date: "16 Aug, 2024",
    time: "12:30 PM",
    amount: 99473.34,
    tenor: 6,
    status: "successful",
  },
  {
    id: "4",
    date: "16 Aug, 2024",
    time: "12:30 PM",
    amount: 994730.34,
    tenor: 3,
    status: "successful",
  },
  {
    id: "5",
    date: "16 Aug, 2024",
    time: "12:30 PM",
    amount: 99473.34,
    tenor: 9,
    status: "pending",
  },
];

export const selectedSavingsListData: ISelectedSavingsListData[] = [
  {
    id: "1",
    startDate: "16 Aug, 2024",
    endDate: "16 Aug, 2024",
    savingsName: "Flex Savings",
    savingsType: "Flex",
    targetAmount: 0,
    savedAmount: 99473.34,
    interestEarned: 20,
    status: "active",
  },
  {
    id: "2",
    startDate: "16 Aug, 2024",
    endDate: "16 Aug, 2024",
    savingsName: "My Life Savings",
    savingsType: "Goal",
    targetAmount: 2500000,
    savedAmount: 99473.34,
    interestEarned: 20,
    status: "completed",
  },
  {
    id: "3",
    startDate: "16 Aug, 2024",
    endDate: "16 Aug, 2024",
    savingsName: "House Rent",
    savingsType: "Goal",
    targetAmount: 2500000,
    savedAmount: 99473.34,
    interestEarned: 20,
    status: "active",
  },
  {
    id: "4",
    startDate: "16 Aug, 2024",
    endDate: "16 Aug, 2024",
    savingsName: "New Car",
    savingsType: "Goal",
    targetAmount: 2500000,
    savedAmount: 99473.34,
    interestEarned: 20,
    status: "active",
  },
  {
    id: "5",
    startDate: "16 Aug, 2024",
    endDate: "16 Aug, 2024",
    savingsName: "New Phone",
    savingsType: "Goal",
    targetAmount: 2500000,
    savedAmount: 99473.34,
    interestEarned: 20,
    status: "active",
  },
];

export const selectedSavingsHistoryData: ISelectedSavingsHistoryData[] = [
  {
    id: "1",
    transactionDateAndTime: "30th Mar, 2024 at 2:30 pm",
    isCredit: true,
    transactionName: "Auto Top Up",
    amount: 99473.34,
  },
  {
    id: "2",
    transactionDateAndTime: "30th Mar, 2024 at 2:30 pm",
    isCredit: true,
    transactionName: "Auto Top Up",
    amount: 99473.34,
  },
  {
    id: "3",
    transactionDateAndTime: "30th Mar, 2024 at 2:30 pm",
    isCredit: true,
    transactionName: "Auto Top Up",
    amount: 99473.34,
  },
  {
    id: "4",
    transactionDateAndTime: "30th Mar, 2024 at 2:30 pm",
    isCredit: false,
    transactionName: "Withdrawal",
    amount: 99473.34,
  },
  {
    id: "5",
    transactionDateAndTime: "30th Mar, 2024 at 2:30 pm",
    isCredit: true,
    transactionName: "Interest Earned",
    amount: 99473.34,
  },
  {
    id: "6",
    transactionDateAndTime: "30th Mar, 2024 at 2:30 pm",
    isCredit: true,
    transactionName: "Auto Top Up",
    amount: 99473.34,
  },
  {
    id: "7",
    transactionDateAndTime: "30th Mar, 2024 at 2:30 pm",
    isCredit: true,
    transactionName: "Auto Top Up",
    amount: 99473.34,
  },
  {
    id: "8",
    transactionDateAndTime: "30th Mar, 2024 at 2:30 pm",
    isCredit: true,
    transactionName: "Auto Top Up",
    amount: 99473.34,
  },
];

export const selectedWithdrawalHistoryData: ISelectedWithdrawalHistoryData[] = [
  {
    id: "1",
    amount: 29473.34,
    payer: "Employer",
    fee: 525.34,
    reason: "Others",
    status: "pending",
    dateRequested: "30th Mar, 2024 at 1:30 pm",
    dateApproved: "30th Mar, 2024 at 1:30 pm",
  },
  {
    id: "2",
    amount: 29473.34,
    payer: "Employer",
    fee: 525.34,
    reason: "Others",
    status: "successful",
    dateRequested: "30th Mar, 2024 at 1:30 pm",
    dateApproved: "30th Mar, 2024 at 1:30 pm",
  },
  {
    id: "3",
    amount: 29473.34,
    payer: "Employer",
    fee: 525.34,
    reason: "Others",
    status: "successful",
    dateRequested: "30th Mar, 2024 at 1:30 pm",
    dateApproved: "30th Mar, 2024 at 1:30 pm",
  },
  {
    id: "4",
    amount: 29473.34,
    payer: "Employer",
    fee: 525.34,
    reason: "Others",
    status: "rejected",
    dateRequested: "30th Mar, 2024 at 1:30 pm",
    dateApproved: "30th Mar, 2024 at 1:30 pm",
  },
  {
    id: "5",
    amount: 29473.34,
    payer: "Employer",
    fee: 525.34,
    reason: "Others",
    status: "successful",
    dateRequested: "30th Mar, 2024 at 1:30 pm",
    dateApproved: "30th Mar, 2024 at 1:30 pm",
  },
  {
    id: "6",
    amount: 29473.34,
    payer: "Employer",
    fee: 525.34,
    reason: "Others",
    status: "successful",
    dateRequested: "30th Mar, 2024 at 1:30 pm",
    dateApproved: "30th Mar, 2024 at 1:30 pm",
  },
];

export const IndividualTypeColorMap: Record<string, IIndividualTypeColor> = {
  0: {
    color: "#344054",
    bg: "#F2F4F7",
  },
  1: {
    color: "#344054",
    bg: "#F2F4F7",
  },
  3: {
    color: "#175CD3",
    bg: "#EFF8FF",
  },
};

export const COLORS: string[] = [
  "#163FA5", // Deep Blue
  "#4A148C", // Deep Purple
  "#D84315", // Deep Orange
  "#C62828", // Deep Red
  "#2E7D32", // Deep Green
  "#283593", // Indigo
  "#6A1B9A", // Violet
  "#1565C0", // Royal Blue
  "#8E24AA", // Amethyst
  "#FF6F00", // Deep Amber
];
